// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"223":"2dd3166d3b3042541ec6","231":"5959552c722beadfdcc3","589":"40618d81718506b2eb80","774":"3925e055040288959c85"}[chunkId] + ".js";
};